/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactClass = _interopRequireDefault(require("../../../../packages/react-class"));
var _join = _interopRequireDefault(require("../../../../common/join"));
var _cleanProps = _interopRequireDefault(require("../../../../common/cleanProps"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var MenuItemCell = function (_Component) {
  (0, _inherits2.default)(MenuItemCell, _Component);
  var _super = _createSuper(MenuItemCell);
  function MenuItemCell() {
    (0, _classCallCheck2.default)(this, MenuItemCell);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(MenuItemCell, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var cellProps = props.cellProps,
        rootClassName = props.rootClassName,
        align = props.align,
        rtl = props.rtl;
      var children = props.expander || props.children;
      var className = (0, _join.default)(props.className, cellProps.className, "".concat(rootClassName, "__cell"), rtl ? "".concat(rootClassName, "__cell--rtl") : "".concat(rootClassName, "__cell--ltr"), props.isDescription && "".concat(rootClassName, "__cell--secondaryLabel"), props.isIcon && "".concat(rootClassName, "__cell--icon"));
      var style = _objectSpread(_objectSpread({}, props.style), cellProps.style);
      if (align) {
        style.textAlign = align;
      }
      return _react.default.createElement("td", _objectSpread(_objectSpread(_objectSpread({}, (0, _cleanProps.default)(props, MenuItemCell.propTypes)), cellProps), {}, {
        style: style,
        className: className
      }), children);
    }
  }]);
  return MenuItemCell;
}(_reactClass.default);
exports.default = MenuItemCell;
MenuItemCell.defaultProps = {
  cellProps: {}
};
MenuItemCell.propTypes = {
  isDescription: _propTypes.default.bool,
  isIcon: _propTypes.default.bool,
  rootClassName: _propTypes.default.string,
  column: _propTypes.default.object,
  cellProps: _propTypes.default.object,
  rtl: _propTypes.default.bool,
  expander: _propTypes.default.node,
  align: _propTypes.default.oneOf(['start', 'end', 'center', 'left', 'right'])
};